import { ShipmentStatus } from '#/shared/api/generated/shipment/models'

export const QUOTE_MARK_AS_STATUSES = [
  ShipmentStatus.quote,
  ShipmentStatus.follow_up,
  ShipmentStatus.ongoing,
  ShipmentStatus.upcoming,
  ShipmentStatus.on_hold,
  ShipmentStatus.archived,
] as const

export type QuoteMarkAsStatus = (typeof QUOTE_MARK_AS_STATUSES)[number]

const LABEL_KEY: Record<QuoteMarkAsStatus, string> = {
  [ShipmentStatus.quote]: 'detailToolbar.markAsOptions.quote',
  [ShipmentStatus.follow_up]: 'detailToolbar.markAsOptions.followUp',
  [ShipmentStatus.ongoing]: 'detailToolbar.markAsOptions.ongoing',
  [ShipmentStatus.upcoming]: 'detailToolbar.markAsOptions.upcoming',
  [ShipmentStatus.on_hold]: 'detailToolbar.markAsOptions.onHold',
  [ShipmentStatus.archived]: 'detailToolbar.markAsOptions.archived',
}

export function quoteMarkAsLabelKey(status: QuoteMarkAsStatus): string {
  return LABEL_KEY[status]
}
